import styled from "styled-components";

const EditIconStyled = styled.img`
  height: 18px;
`;

export default EditIconStyled;
